import React from 'react';
import clsx from 'clsx';

interface PushSidebarProps {
  menuShowing: boolean;
}

const PushSidebar = ({
  children,
  menuShowing,
}: React.PropsWithChildren<PushSidebarProps>) => (
  <aside
    className={clsx(
      'transition-all duration-300 ease-in-out text-sm',
      'fixed top-0 w-64 h-screen',
      menuShowing ? 'left-0' : '-left-64',
      'md:left-0',
    )}
  >
    {children}
  </aside>
);

interface PushMainProps {
  className?: string;
  menuShowing: boolean;
}

const PushMain = ({
  children,
  className,
  menuShowing,
}: React.PropsWithChildren<PushMainProps>) => (
  <div className={clsx(className, menuShowing ? 'ml-64' : 'ml-0', 'md:ml-64')}>
    {children}
  </div>
);

interface PushProps {
  className?: string;
  menuShowing: boolean;
  sidebar: React.ReactNode;
}

export const Push = ({
  children,
  className,
  menuShowing,
  sidebar,
}: React.PropsWithChildren<PushProps>) => {
  return (
    <div className="relative flex h-screen">
      <PushSidebar menuShowing={menuShowing}>{sidebar}</PushSidebar>

      <PushMain className={className} menuShowing={menuShowing}>
        {children}
      </PushMain>
    </div>
  );
};
